export interface MissingFieldInfoLike {
  is_optional?: boolean | null;
}

export function isOptionalMissingField(
  field: MissingFieldInfoLike | null | undefined,
): boolean {
  return field?.is_optional === true;
}

export function countBlockingMissingFields<T extends MissingFieldInfoLike>(
  missingFields: Record<string, T> | null | undefined,
): number {
  return Object.values(missingFields ?? {}).filter(
    (field) => !isOptionalMissingField(field),
  ).length;
}

export function hasBlockingMissingFields<T extends MissingFieldInfoLike>(
  missingFields: Record<string, T> | null | undefined,
): boolean {
  return countBlockingMissingFields(missingFields) > 0;
}
